import { type FC, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { BarChartCard } from "@/partner/shared/components/BarChartCard";
import type { CalendarIntervalValue } from "@/partner/shared/components/AnalyticsCalendarInterval";
import { useUsageHistoryQuery } from "@/partner/entities/storage";

// Технические метки серий с бэкенда (usageHistory.items[].label) — не
// переводятся напрямую (CRITICAL-RULES.md — i18n: ключ i18n только
// статический литерал), маппятся на ключи через явную статическую мапу.
const SERIES_LABEL_KEYS: Record<string, string> = {
  storage: "usage.history.storage",
  delivery: "usage.history.delivery",
};

export const UsageHistoryChart: FC = () => {
  const { t } = useTranslation();
  const [calendarInterval, setCalendarInterval] =
    useState<CalendarIntervalValue>();

  const dateTo = useMemo(() => moment().endOf("day").toISOString(), []);
  const dateFrom = useMemo(
    () => moment().subtract(30, "days").startOf("day").toISOString(),
    []
  );

  const { data, loading, error } = useUsageHistoryQuery({
    variables: {
      dateFrom,
      dateTo,
      calendarInterval: calendarInterval as never,
    },
  });

  const chart = data?.usageHistory
    ? {
        ...data.usageHistory,
        items: data.usageHistory.items.map((item) => ({
          ...item,
          label: t(SERIES_LABEL_KEYS[item.label] ?? "usage.history.other"),
        })),
      }
    : undefined;

  return (
    <BarChartCard
      title={t("usage.history.title")}
      chart={chart}
      loading={loading}
      error={error}
      dateFrom={dateFrom}
      dateTo={dateTo}
      onChangeCalendarInterval={setCalendarInterval}
    />
  );
};
